import request from '@aned/request';

// 获取列表
export async function getList(params) {
  return request('/api/route/od/departmentCargoVolumeMatrix/select', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
